import React from 'react'
import './404.css'
import HeaderBar from '../../component/header/header.js'
import { Link} from "react-router-dom"
class W404 extends React.Component{
	render(){
		return(
			<div>

				<HeaderBar></HeaderBar>
				<div className="w404cls">
					<Link to="/index">返回首页</Link>
				</div>
			</div>
			
		)
	}
}
export default W404


// WEBPACK FOOTER //
// ./src/container/404/404.js